import { put, takeLatest } from 'redux-saga/effects';
import { ProjectId, UserId } from 'api/models';
import { ProjectAPI } from 'api/project';
import { removeMembersFromProject } from 'data/projects/actions';
import { getProjectMembersQueryKey, queryClient } from 'queries';
import { MEMBERS_V2_MODIFIED_QUERY_KEY, MEMBERS_V2_QUERY_KEY } from 'queries/members';
import { getPlaceholderResolutionByProjectQueryKeyV2, PlaceholderResolutionsQueryKey } from 'queries/placeholder';
import { logger } from 'services';
import { remove } from 'stores/memberships';
function* removeMemberFromProjectSaga(action) {
    const { payload } = action;
    const { projectId, members, handleSuccess, handleFailure } = payload;
    try {
        // TODO: no response on remove call, can use response once thats available @krishna
        yield ProjectAPI.removeMembers(projectId, members);
        if (handleSuccess) {
            handleSuccess(payload);
        }
        yield put(remove({
            projectId: ProjectId(projectId),
            userIds: payload.members.map(({ userId })=>UserId(userId))
        }));
        yield queryClient.invalidateQueries(getProjectMembersQueryKey(ProjectId(projectId)));
        yield queryClient.invalidateQueries(MEMBERS_V2_QUERY_KEY);
        yield queryClient.invalidateQueries(MEMBERS_V2_MODIFIED_QUERY_KEY);
        yield queryClient.invalidateQueries(getPlaceholderResolutionByProjectQueryKeyV2(ProjectId(projectId)));
        yield queryClient.invalidateQueries(PlaceholderResolutionsQueryKey);
    } catch (error) {
        logger.error('removeMembers failed', {
            error
        });
        if (handleFailure) {
            handleFailure(error);
        }
    }
}
export const watchRemoveMemberFromProjectSaga = function*() {
    yield takeLatest(removeMembersFromProject.type, removeMemberFromProjectSaga);
};
